module.exports = __webpack_public_path__ + "static/media/github.d22ee372.png";